import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/auth';

export default function Logout() {
    const navigate = useNavigate();
    const { logoutUser } = useContext(AuthContext);

    useEffect(() => {
        logoutUser();
        navigate("/");
    }, []);
}
